import { isDappSupported, isWalletAuthLogin } from '@/utils/authRedirect'

let started = false
let recheckTimer = null

function readStoredUser() {
	try {
		return JSON.parse(localStorage.getItem('userInfo') || 'null')
	} catch (e) {
		return null
	}
}

function shouldCheck(store) {
	if (!store || !store.state.isLogin) return false
	if (localStorage.getItem('isLogin') !== 'true' || !localStorage.getItem('token')) return false
	if (!isDappSupported()) return false
	const user = store.state.userInfo || readStoredUser()
	if (!user || !isWalletAuthLogin(user) || Number(user.userType) === 2) return false
	return true
}

function recheck(store) {
	if (recheckTimer) {
		clearTimeout(recheckTimer)
	}
	recheckTimer = setTimeout(() => {
		if (!shouldCheck(store)) return
		store.dispatch('GET_USER_INFO').catch(() => {})
	}, 200)
}

export function startWalletAddressGuard(store) {
	if (started || typeof window === 'undefined') return
	started = true

	if (window.ethereum && typeof window.ethereum.on === 'function') {
		window.ethereum.on('accountsChanged', () => recheck(store))
	}

	const tronProvider = window.tron || window.tronLink
	if (tronProvider && typeof tronProvider.on === 'function') {
		tronProvider.on('accountsChanged', () => recheck(store))
	}

	window.addEventListener('message', (event) => {
		const action = event.data && event.data.message && event.data.message.action
		if (action === 'setAccount' || action === 'accountsChanged') {
			recheck(store)
		}
	})
}
